angular.module('acme.common.directive.history.modal', [])
.controller('historyModalCtrl', [ '$scope', '$filter', '$uibModalInstance', '$timeout', 'items', function($scope, $filter, $uibModalInstance, $timeout, items){
  var self = $scope.history;
    
  $scope.$on('auditTrail::modalClosed', $scope.closeModal);

  $scope.closeModal = function(){
    $uibModalInstance.dismiss();
  };
  
  $scope.gridOptions = {
    columnDefs: self.columns,
    rowData: null,
    rowSelection: 'single',
    enableSorting: true,
    enableServerSideSorting: true,
    rowModelType: 'pagination',
    enablePagination: false,
    onGridReady: function () {
      self.setDataForGrid($scope.gridOptions, items);
      $timeout(self.gridResizeTimeout, 10);
    },
    rowHeight: 30,
    headerHeight: 30,
    localeText: {
      page: '&nbsp;',
      next: '<span class="fa fa-caret-right fa-lg"></span>',
      last: '<span class="fa fa-step-forward fa-md"></span>',
      first: '<span class="fa fa-step-backward fa-md"></span>',
      previous: '<span class="fa fa-caret-left fa-lg"></span>'
    },
    icons: {
      sortAscending: '<span class="fa fa-caret-down"/>',
      sortDescending: '<span class="fa fa-caret-up"/>'
    },
    overlayLoadingTemplate: '<span class="ag-overlay-loading-center text-center inactive">Loading...</span>',
    overlayNoRowsTemplate: '<span class="ag-overlay-no-items text-center inactive">There is no history to display.</span>',
    onRowDoubleClicked: self.onGridDblClick
  };
  
}]);
